import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';

import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContentService } from 'src/app/views/content/content.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-course-content-sorter',
  templateUrl: './course-content-sorter.component.html',
  styleUrls: ['./course-content-sorter.component.css'],
  standalone: true,
  imports: [TranslateModule, MatDialogModule, DragDropModule, MatCardModule, MatButtonModule],
})
export class CourseContentSorterComponent implements OnInit {
  data;
  elements = [];

  constructor(
    @Optional() private dialogRef: MatDialogRef<CourseContentSorterComponent>,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<CourseContentSorterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
    private contentService: ContentService,
    private toast: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.data = this.dialogData || this.bottomSheetData;
    if (this.data.type == 'section') {
      this.elements = this.data.sections;
    } else if (this.data.type == 'lecture') {
      this.elements = this.data.lectures;
    }
  }

  drop(event) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }

  save() {
    let list;
    if (this.data.type == 'section') {
      list = this.data.sections;
    } else if (this.data.type == 'lecture') {
      list = this.data.lectures;
    }
    const result = list.map((element, index) => {
      return { _id: element._id, index };
    });
    const data = {
      type: this.data.type,
      array: result,
      courseID: this.data.courseID,
      sectionID: this.data.sectionID,
    };
    this.contentService.setSectionLectureOrder(data).subscribe(
      (res) => {
        this.closeSorter(true);
      },
      (err) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
          duration: 2000,
        });
      }
    );
  }
  cancel() {
    this.closeSorter();
  }

  closeSorter(output = false) {
    if (this.dialogData) {
      this.dialogRef.close(output);
    } else {
      this.bottomSheetRef.dismiss(output);
    }
  }
}
